// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { buildParameterSerializer } from "@coveo/headless-react/ssr-commerce";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { isCoveoLoading } from "@NA/Utils/Coveo/CoveoUtils";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { HasCoveoHooks, withCoveoHooks } from "./Contexts/CoveoHooksContext";

const mapStateToProps = (state: CustomApplicationState) => ({
    isCoveoLoading: isCoveoLoading(state.ADIGlobalData.coveoCommerce),
});

type Props = ReturnType<typeof mapStateToProps> & HasCoveoHooks;

const CoveoParameterManager = ({ isCoveoLoading, parameterManager }: Props) => {
    if (typeof window === "undefined") return null;

    const { state, methods } = parameterManager;
    const { serialize, deserialize } = buildParameterSerializer();
    const previousUrl = useRef(window.location.href);
    const [isCoveoLoaded, setIsCoveoLoaded] = useState(false);

    useEffect(() => {
        previousUrl.current = location.href;
    }, [location.pathname]);

    useEffect(() => {
        if (!methods) return;

        const newCommerceParams = deserialize(new URLSearchParams(location.search));
        const newUrl = serialize(newCommerceParams, new URL(location.href));
        const isPathsEqual = new URL(previousUrl.current).pathname.toLowerCase() === location.pathname.toLowerCase();

        if (previousUrl.current === newUrl || !isPathsEqual) return;

        previousUrl.current = newUrl;
        methods.synchronize(newCommerceParams);
    }, [location.search]);

    useEffect(() => {
        if (isCoveoLoading) {
            setIsCoveoLoaded(false);
            return;
        } else if (!isCoveoLoading && !isCoveoLoaded) {
            setIsCoveoLoaded(true);
            return;
        } else if (Object.keys(state?.parameters || {}).length === 0) {
            return;
        }

        const newUrl = serialize(state.parameters, new URL(window.location.origin + window.location.pathname));
        if (previousUrl.current === newUrl) {
            return;
        }

        previousUrl.current = newUrl;
        window.history.pushState(null, document.title, newUrl);
    }, [state?.parameters]);

    return null;
};

export default connect(mapStateToProps)(withCoveoHooks(CoveoParameterManager));
